/* eslint-disable indent */
export default class HandleToggle {
  constructor(elements) {
    this.triggers = elements;
    this._setDOMReferences();
  }

  _setDOMReferences() {
    Array.from(this.triggers).forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Toggle clicked:', element);
        
        if (element.hasAttribute("data-set-passive-id")) {
          this.update(element.dataset.setPassiveId, 'passive');
        }

        const id = element.dataset.toggleId;
        let state = element.dataset.state;
        state = (state === 'passive') ? 'active' : 'passive';
        console.log('Updating state:', id, state);
        this.update(id, state);
      });
    });
  }

  update(id, state) {
    const elements = document.querySelectorAll(`[data-toggle-id="${id}"]`);
    console.log('Found elements to update:', elements.length);
    
    elements.forEach((element) => {
      console.log('Updating element:', element, 'to state:', state);
      element.setAttribute('data-state', state);
    });
  }
}
